import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import {
	StyledContainer,
	StyledImage,
	StyledInfoContainer,
	StyledLastMessage,
	StyledLeftContainer,
	StyledNameContainer,
	StyledNewMessagesCounter,
	StyledTime,
} from './AppMessengerDialogItem.styled';

const AppMessengerDialogItem = ({
	name,
	online,
	time,
	unread,
	unreadCount,
	lastMessage,
	active,
	onClick,
}: {
	name: string;
	online?: boolean;
	time: string;
	unread?: boolean;
	unreadCount?: number;
	lastMessage?: string;
	active?: boolean;
	onClick?: () => void;
}) => {
	return (
		<StyledContainer
			$active={active}
			onClick={() => {
				onClick?.();
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledLeftContainer>
				<StyledImage $online={online} />
				<StyledInfoContainer>
					<StyledNameContainer>
						<Text>{name}</Text>
						{online && <div className={'dot'} />}
					</StyledNameContainer>
					<StyledLastMessage $unread={unread}>
						{lastMessage ?? ''}
					</StyledLastMessage>
				</StyledInfoContainer>
			</StyledLeftContainer>
			{unread && (
				<StyledNewMessagesCounter>
					<Text>{unreadCount ?? 1}</Text>
				</StyledNewMessagesCounter>
			)}
			{!unread && <StyledTime>{time}</StyledTime>}
		</StyledContainer>
	);
};

export { AppMessengerDialogItem };
